import { useQuery } from "@tanstack/react-query";
import { GET_CUSTOM_ADDRESSES_FOR_SHIPMENT } from "@/constants/Query";
import { apiRequest } from "@/utils/apiRequest";
import { IAddressesList } from "@/types/apiResponse.types";

export const useGetCustomAddressesForShipmentRequest = () => {
  return useQuery<{ data: { data: IAddressesList[] } }>({
    queryKey: [GET_CUSTOM_ADDRESSES_FOR_SHIPMENT],
    queryFn: () => apiRequest(GET_CUSTOM_ADDRESSES_FOR_SHIPMENT, "get"),
  });
};
